module.exports = __webpack_public_path__ + "img/under-maintenance.95d96438.png";